export default __webpack_public_path__ + "0e96171a555d85227eec92ca2396787f.svg";